{
    "addToCart": "Zum Warechorb hinzuefüege",
    "yes": "Ja",
    "no": "Nei",
    "login": "Iilogge",
    "cancel": "Abbräche",
    "close": "Schlüüsse",
    "couponApplied": "Rabatt agwendet!",
    "unappliedCoupon": {
        "title": "Rabatt nöd agwendet",
        "description": "Scan s’passende Produkt zum dä Rabatt übercho."
    },
    "done": "Fertig",
    "welcome": "Willkommä",
    "welcomeScan": "Zahl bequäm und eifach via Self-Checkout",
    "total": "Total",
    "toPayment": "Zur Bezahlig",
    "back": "Zrugg",
    "quantityNeeded": "Benötigti Mängi",
    "confirmCart": "Sind alli Artikel gscannt worde?",
    "interactWithTerminal": "Benutz s’Zahligsterminal zum dä Chauf abschlüsse",
    "endTitle": "Chauf erfolgriich!",
    "endSubtitle": "Du bisch startklar. Mir freued eus, dass du bi eus iichaufsch!",
    "feedbackQuestion": "Wie isch dini Erfahrig gsi?",
    "endThanksForFeedback": "Danke für dis Feedback!",
    "endSeeYouLater": "Mir freued eus uf din nöchste Bsuech.",
    "getReceipt": "Quittig",
    "scanQRCode": "Scan dä QR Code zum dini digitali Quittig abelade.",
    "printReceipt": "Quittig usdrucke",
    "receiptPrinted": "✔ Quittig usdruckt",
    "finalizeSession": "Abschlüüsse",
    "productNotFound": "Ups! Mir chönd dä Artikel nöd finde",
    "okDismiss": "OK",
    "somethingWentWrong": "Öppis isch schiäf gloffe",
    "pleaseTryAgain": "Bitte nomal probiere",
    "pleaseWait": "Ein Momänt...",
    "tryAgain": "Nomal probiere",
    "reload": "Nomal lade",
    "stillThere": "Bisch no da?",
    "continue": "Wiiter",
    "startOver": "Neu aafange",
    "scan": "Scan en Artikel, um en zu diim Warechorb hinzuezfüege",
    "wantToStartOver": "Bisch sicher, dass neu wotsch aafange?",
    "wantToStartOverDescription": "Alli gscannte Artikel wärded us dim Warechorb glöscht.",
    "changeLanguage": "Sprach wächsle",
    "ageVerification": "Uswiis scanne, zum s’Alter überprüefe",
    "scanId": "Zum das Produkt chaufe, muesch din <strong>Uswiis iiscanne</strong> zum dis Alter z’verifiziere.",
    "holdIdSteady": "<strong>Hiwiis:</strong> Bitte heb din Uswiis ruhig id Richtig vom Scanner",
    "sorryCantSell": "Tuet eus leid, mir chönd dir das Produkt nöd verchaufe",
    "sorryCantSellDescription": "Mir chönd das Produkt nume a Persone über 18 Jahr verchaufe.",
    "invalidId": "Mir händ dä Uswis nöd chöne läse. Bitte nomal versueche",
    "verificationSuccessful": "Verifizierig erfolgriich!",
    "startShopping": "Iichauf starte",
    "startShoppingKitchen": "Esse bstelle",
    "wantToDeleteLineItem": "Bisch sicher, dass dä Artikel lösche wotsch?",
    "wantToDeleteLineItemDescription": "Das Produkt wird us dim Warechorb entfernt.",
    "promotionsDontWork": "<strong>Hiiwiis:</strong> Produkt mit Aktione funktioniered nonig uf dere Kasse",
    "addToBasket": "Hinzuefüege",
    "promo": "Aktion",
    "product": "Produkt",
    "productAdded": "Produkt hinzuegfüegt!",
    "product_other": "Produkt",
    "operatorModeDialog": {
        "title": "Bruchsch hilf?",
        "description": "Für wiiteri Aktione bitte dä Mitarbeiter Code scanne."
    },
    "orderList": {
        "collapseDetails": "Iiklappe",
        "expandDetails": "Usklappe",
        "details": "Details",
        "title": "Bstellige"
    },
    "checkoutError": {
        "default": "Ups, dini Zahlig het nöd funktioniert. Bitte nomal probiere",
        "AbortedByUser": "D’Zahlig isch storniert worde. Bitte probiers nomal.",
        "PaymentDeviceNotFound": "Für diesen SCO konnte kein Payment Terminal gefunden werden.",
        "CouponNotFound": {
            "title": "Coupon nöd gfunde",
            "description": "Dä Coupon cha nöd aagwändet werde, wil er nöd gfunde werde cha."
        },
        "CouponNotApplicable": {
            "title": "Coupon nöd aagwändbar",
            "description": "Dä Coupon passt zu keim Artikel i dim Chorb. Bitte scann zerscht s'Produkt."
        },
        "CouponExpired": {
            "title": "Coupon abgloffe",
            "description": "Dä Coupon cha nöd aagwändet werde, wil er abgloffe isch."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon scho brucht",
            "description": "Dä Coupon cha nöd aagwändet werde, wil er scho brucht worde isch."
        },
        "CouponRedemptionFailed": {
            "title": "Coupon-Iilösung fehlgschlage",
            "description": "Dä Coupon cha nöd iiglösed werde. Bitte versuch's nomal."
        }
    },
    "operatorMode": "Operator-Modus",
    "operator": {
        "configuration": {
            "title": "Konfiguration",
            "individualConfig": {
                "title": "SCO-Konfiguration"
            },
            "storeConfig": {
                "title": "Verchaufstell Konfiguration"
            },
            "status": {
                "label": "SCO aktiviert",
                "confirmDisable": "Bisch sicher, dass du s SCO deaktiviere wotsch?",
                "confirmEnable": "Bisch sicher, dass du s SCO aktiviere wotsch?"
            },
            "cartCheck": {
                "label": "Warenkorbprüefig aktiviert",
                "confirmDisable": "Bisch sicher dass de SCO deaktiviere wotsch?",
                "confirmEnable": "Bisch sicher dass de SCO aktiviere wotsch?"
            }
        },
        "hardware": {
            "title": "Hardware",
            "lamp": "Lampe",
            "printer": "Drucker",
            "scanner": "Scanner",
            "red": "Rot",
            "green": "Grün",
            "print": "Testbeleg drucken",
            "clear": "Zurücksetzen",
            "blink": "Blinken",
            "paymentTerminal": "Zahlungsterminal",
            "login": "Iilogge",
            "paymentDeviceConfig": {
                "currentIp": "Aktuelli IP-Adresse",
                "ipLabel": "Nöii IP-Adresse",
                "invalidIp": "Ungültigi IP-Adresse",
                "setIp": "IP setze",
                "probe": "Prüefe",
                "probeSucceeded": "Prüefig erfolgriich",
                "probeFailed": "Prüefig fehlgschlage",
                "loginSucceeded": "Aamäldig erfolgriich",
                "loginFailed": "Aamäldig fehlgschlage: {{reason}}",
                "status": "Status",
                "statuses": {
                    "ready": "Parat",
                    "requiresLogin": "Aamäldig nötig",
                    "unreachable": "Nöd erreichbar"
                },
                "ipUpdated": "IP-Adresse aktualisiert",
                "ipUpdateFailed": "IP-Adresse hät nöd chönne aktualisiert werde: {{reason}}",
                "alterIp": "IP ändere",
                "dialogTitle": "Zahligsterminal-IP",
                "close": "Schlüsse"
            }
        },
        "systemInformation": {
            "title": "Systeminformationen",
            "deviceId": "Geräte-ID",
            "cashRegisterId": "SAP Kasse-ID",
            "paymentDeviceId": "Zahlungsgerät-ID",
            "paymentDeviceIp": "Zahlungsgerät-IP",
            "runningVersion": "Laufende Version",
            "storeId": "Filial-ID",
            "productPresetIds": "Produktvoreinstellungs-IDs",
            "kitchenMenuId": "The Kitchen menuü-ID",
            "tenant": "Mieter"
        }
    },
    "order": "Bstellig",
    "order_other": "Bstellige",
    "insight": "Insight",
    "insight_other": "Insights",
    "insightGrouping": {
        "groupBy": "Gruppieren",
        "scoId": "Self-checkout",
        "category": "Kategorie"
    },
    "productCategory": {
        "label": "Kategorie",
        "ABF": "Abfall",
        "BTRM": "Betriebsmaterial",
        "BUCH": "Büecher",
        "CBAU": "Compatible unit",
        "CH00": "CH Vertragsverwaltig",
        "CONT": "KANBAN-Behälter",
        "COUP": "Coupon",
        "DIEN": "Dienstleistig n.best.gef",
        "DLU1": "Dienstleistig best.gef.",
        "EPA": "Uusstattigspaket",
        "ERSA": "Ersatzteil",
        "FERT": "Fertigerzügnis",
        "FGTR": "Getränk",
        "FHMI": "Fertigungshilfsmittel",
        "FOOD": "Food (excl. Früschi)",
        "FRIP": "Früschprodukt",
        "HALB": "Halbfabrikat",
        "HAWA": "Handelswaar",
        "HERS": "Herstellerteil",
        "HIBE": "Hilfs-/Betriebsstoff",
        "IBAU": "Instandhaltigs-Baugruppe",
        "INTR": "Intramaterial",
        "KMAT": "Konfigurierbars Material",
        "LEER": "Lärguet",
        "LEIH": "Leihguet-Packmittel",
        "LGUT": "Lärguet (zu VOLL)",
        "MODE": "Mode (saisonal)",
        "MPO": "Materialplanigsobjekt",
        "NLAG": "Nichtlagermaterial",
        "NOF1": "Non Food",
        "PIPE": "Pipeline-Material",
        "PLAN": "Handelswaar (plant)",
        "PRES": "Präss",
        "PROC": "Prozäss-Material",
        "PROD": "Produktgruppe",
        "ROH": "Rohstoff",
        "TBAK": "Tabak",
        "UNBW": "Unbewertetes Material",
        "VBFO": "Verbruuchsmat. FOOD",
        "VERP": "Verpackig",
        "VKHM": "Verchaufshilfsmittel",
        "VOLL": "Vollguet",
        "WERB": "Werbemittel",
        "WERT": "Wertmaterial",
        "WETT": "Wettbewerberprodukt",
        "ZAUF": "Uufwandsartikel",
        "ZAUS": "Präss - Uusgab",
        "ZFRG": "Franchising Gebühre",
        "ZGIF": "Ravita Giftcards",
        "ZILV": "AGS: Int. Leistungsverr.",
        "ZITP": "AGS: IT-Projekte",
        "ZLEI": "Leihguet Kiosk AG",
        "ZLOG": "Dienstleistige Logistik",
        "ZMFE": "AGS: Management fee",
        "ZOBJ": "Präss - Objekt",
        "ZRAV": "Ravita PinCodes",
        "ZSER": "AGS: Serviceartikel"
    },
    "totalRevenue": "Gsamtumsatz",
    "needReceipt": "<strong>Bruchsch du e Quittig?</strong> Du findisch sie unter Iistellige > Kaufhistorie",
    "orderNumber": "Bstellig",
    "takeReceipt": "<strong>Wichtig</strong>: Gib dä Bestellschein bim Chuchipersonal ab, wänn dini Bstellig bereit isch.",
    "kitchen": "Kitchen",
    "theKitchen": "The Kitchen",
    "kitchenMenu": {
        "backToCart": "Zum Warechorb",
        "productUnavailable": "Nöd verfüegbar",
        "allergens": "Allergen",
        "nutritionalInformation": "Zuetate und Ursprung",
        "productInformation": "Produktinfos",
        "upsellingTitle": "No öpis dezue?"
    },
    "availableAtAvec": "Verfüegbar i dem avec",
    "kitchenDescription": "Druck dä chnopf zum s’Menü ufmache",
    "unknown": "Unbekannt",
    "dateRangePicker": {
        "from": "Von",
        "to": "Bis"
    },
    "outOfOrder": {
        "title": "Ups! Ein Problem ist aufgetreten",
        "subtitle": "Die Selbstbedienungskasse ist vorübergehend ausser Betrieb, aber wir arbeiten mit Hochdruck daran, das Problem zu beheben."
    },
    "cartCheckTriggered": "Din Warechorb isch zuefällig für e manuelli Kontrolle usgwählt worde. Bitte wartet bis en Mitarbeiter zu dir chunnt.",
    "cartError": {
        "Unknown": {
            "title": "Ups! Ein Problem ist aufgetreten. Bitte nochmal versuchen"
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon scho iiglösed",
            "body": "Dä Coupon isch scho iiglösed worde. Bitte überprüef dä Coupon und versuech es nomol."
        },
        "ServiceNotSellable": {
            "title": "Bitte bruuch e bedienti Kasse",
            "body": "Dä Artikel chasch nur anere bediente Kasse chaufe."
        },
        "CouponNotApplicable": {
            "title": "Coupon nöd aagwändbar",
            "body": "Dä Coupon passt zu keim Artikel i dim Chorb. Bitte scann zerscht s'Produkt."
        }
    }
}
